document.addEventListener("DOMContentLoaded", () => {
    const atcMessages = document.querySelectorAll(".bss-hide-atc");
    atcMessages.forEach(message => {
        if (message.nextElementSibling?.tagName === "FORM") {
            message.nextElementSibling.remove()
        }
    });
    checkAndDisplayMessage()
})

function checkAndDisplayMessage() {
    const cartMessages = Array.from(document.querySelectorAll('.bss-show-lock-messsage'))
    const messageNextToCart = cartMessages.filter((message) => {
        return message.nextElementSibling?.tagName == 'FORM'
    })
    if (messageNextToCart.length > 0) {
        const firstMessage = messageNextToCart[0];

        const computedStyle = window.getComputedStyle(firstMessage);
        
        if (computedStyle.display == 'none') {
            firstMessage.style.display = 'block'
            firstMessage.style.pointerEvents = ''
            firstMessage.style.opacity = 1
        }
    } else {
        if (cartMessages.length > 0) {
            const firstMessage = cartMessages[0];
            const computedStyle = window.getComputedStyle(firstMessage);
            if (computedStyle.display == 'none') {
                firstMessage.style.display = 'block'
                firstMessage.style.pointerEvents = ''
                firstMessage.style.opacity = 1
            }
        } 
    }
}